
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {ExternalApi as ExternalApiService} from "@/simulation/ExternalApi";

    @Component
    export default class ExternalApi extends Vue {
        @Prop() private api!: ExternalApiService;
    }
